import React from 'react';
import { useIntl } from 'react-intl';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';
import { GRANULARITIES } from './reportingFilters';
import messages from '../../../locale/jsonMessages';
import s from './OwnerReporting.css';

const LABELS = { day: 'orpGranDay', week: 'orpGranWeek', month: 'orpGranMonth', year: 'orpGranYear' };

// Day / Week / Month / Year selector of the evolution chart.
const GranularitySelect = ({ value, onChange }) => {
  const { formatMessage } = useIntl();
  return (
    <div className={s.segmented} role="group" aria-label={formatMessage(messages.orpGranLabel)}>
      {GRANULARITIES.map((item) => (
        <button key={item} type="button" aria-pressed={value === item}
          className={cx(s.segment, value === item && s.segmentActive)} onClick={() => item !== value && onChange(item)}>
          {formatMessage(messages[LABELS[item]])}
        </button>
      ))}
    </div>
  );
};

export default withStyles(s)(GranularitySelect);
